import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business ルートインデックス。/pipelinesへ自動リダイレクト
 * @graph-connects none
 */
export const Route = createFileRoute('/')({
  component: IndexPage,
});

/** @graph-connects none */
function IndexPage() {
  return <Navigate to="/pipelines" />;
}
